module.exports = __webpack_public_path__ + "static/flag_im-d4a24e8590e65764c35f0c29a76cdbde.svg";